import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FetchBlacklists, CreateBlacklist, UpdateBlacklist, DeleteBlacklist } from "../actions/blacklist";


interface Blacklist {
  id: string;
  phone_number: string;
  reason: string;
  created_at: string;
  updated_at: string;
}

interface BlacklistsState {
  list: any;
  status: "idle" | "pending" | "success" | "error";
  error: string | null;
}

const initialState: BlacklistsState = {
  list: [],
  status: "idle",
  error: null,
};

const blacklistsSlice = createSlice({
  name: "blacklists",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Blacklists
      .addCase(FetchBlacklists.pending, (state) => {
        state.status = "pending";
      })
      .addCase(FetchBlacklists.fulfilled, (state, action: PayloadAction<Blacklist[]>) => {
        state.status = "success";
        state.list = action.payload;
      })
      .addCase(FetchBlacklists.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload as string;
      })

      // Create Blacklist
      .addCase(CreateBlacklist.pending, (state) => {
        state.status = "pending";
      })
      .addCase(CreateBlacklist.fulfilled, (state, action: PayloadAction<Blacklist>) => {
        state.status = "success";
        state.list.list.push(action.payload);
      })
      .addCase(CreateBlacklist.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload as string;
      })

      // Update Blacklist
      .addCase(UpdateBlacklist.pending, (state) => {
        state.status = "pending";
      })
      .addCase(UpdateBlacklist.fulfilled, (state, action: PayloadAction<Blacklist>) => {
        state.status = "success";
        const updatedBlacklist = action.payload;
        const index = state.list.findIndex((item:any) => item.id === updatedBlacklist.id);
        if (index !== -1) {
          state.list[index] = updatedBlacklist;
        }
      })
      .addCase(UpdateBlacklist.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload as string;
      })
      .addCase(DeleteBlacklist.pending, (state) => {
        state.status = "pending";
      })
      .addCase(DeleteBlacklist.fulfilled, (state) => {
        state.status = "success";
      })
      .addCase(DeleteBlacklist.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload as string;
      });
  },
});

export default blacklistsSlice.reducer;